import angular from 'angular';
import confirmationOrderComponent from './confirmation-order.component';
import ConfirmationOrderService from './confirmation-order.service';
import ModalExperienceController from './modal-experience/modal-experience.controller';
import ModalConfirmationMoraController from './modal-confirmation-mora/modal-confirmation-mora.controller';

let confirmationOrderModule = angular.module('app.confirmationOrder',[])
   .controller('ModalExperienceController', ModalExperienceController)
   .controller('ModalConfirmationMoraController', ModalConfirmationMoraController)
  .component('confirmationOrder', confirmationOrderComponent)
  .service('ConfirmationOrderService', ConfirmationOrderService);

export default confirmationOrderModule;



/** WEBPACK FOOTER **
 ** ./www/components/confirmation-order/confirmation-order.js
 **/